import { __, add, adjust, evolve, merge, repeat, zipWith, T } from 'ramda'

import { createReducer } from 'modules/util'

import ActionType from '../constants/actionTypes'

const emptyParts = repeat(__, 3)({
  dirty: false,
  evidence: '',
  reasoning: '',
  counterargument: ''
})

const startingPositions = [
  { x: 0.85, y: 0.21 },
  { x: 0.85, y: 0.5 },
  { x: 0.85, y: 0.79 }
]

export const initialState = zipWith(merge, emptyParts, startingPositions)

const handlers = {
  [ActionType.UPDATE_PART_LOCATION]: updatePartLocation,
  [ActionType.UPDATE_PART_ELEMENT_VALUE]: updatePartElementValue,
  [ActionType.RESET_BUILDER]: () => initialState
}

export default createReducer(initialState, handlers)

function updatePartLocation(state, { payload: { id, x, y } }) {
  const transformations = { x: add(x), y: add(y), dirty: T }

  return adjust(evolve(transformations), id)(state)
}

function updatePartElementValue(state, { payload }) {
  const { partId, element, value } = payload

  return adjust(part => ({ ...part, [element]: value }), partId)(state)
}



// WEBPACK FOOTER //
// ./client/modules/debate/reducers/builder.js